<!-- Mounted only while open: a closed mj-slide-panel stays in the DOM translated off-screen but keeps its
     box-shadow (ng-ui-components slide-panel.component.js:226), a grey strip on the viewport's right edge. -->
@if (Open) {
<mj-slide-panel Mode="slide" Title="Notifications" (Closed)="Close.emit()">
  <div class="oep-notes" aria-live="polite">
    @if (Items.length === 0) {
      <p class="oep-notes__empty">Nothing new. We email you when a role opens.</p>
    } @else {
      <ul class="oep-notes__list">
        @for (n of Items; track n.ID) {
          <li>
            <button type="button" class="oep-notes__item" [disabled]="Busy" (click)="Pick(n)">
              <span class="oep-notes__dot" [class.oep-notes__dot--unread]="n.Unread" aria-hidden="true"></span>
              <span class="oep-notes__text">
                <span class="oep-notes__title">{{ n.Title }}</span>
                <span class="oep-notes__body">{{ n.Message }}</span>
                <span class="oep-notes__when">{{ n.When }}@if (n.Unread) { <span class="oep-notes__sr"> (unread)</span> }</span>
              </span>
            </button>
          </li>
        }
      </ul>
    }
    @if (IsStaff) {
      <button type="button" class="oep-notes__emails" (click)="OpenEmails.emit()">View the email that triggers each of these →</button>
    }
  </div>
</mj-slide-panel>
}
